var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"donut-chart-container"},[_c('div',{staticClass:"chart-wrapper",style:(_vm.chartWrapperStyle)},[_c('div',{ref:"chart",staticClass:"chart",style:(_vm.chartStyle)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }